import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  apiCallSubscriptionPlanList,
  apiCallSubscriptionUpdatePlanStatus,
} from "../../Core/Apicall";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../Config/Actions/loadingActions";
import PlanList from "../../Components/Subscription/PlanList";
import EmptyData from "../../Components/EmptyData/EmptyData";
import CreatePlanModal from "../../Components/Subscription/CreatePlan";

const SubsriptionList = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.isLoading);
  const [planListData, setPlanListData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [selectedDeletePlan, setSelectedDeletePlan] = useState(null);

  const fetchPlanList = async () => {
    dispatch(setLoadingTrue());
    try {
      const response = await apiCallSubscriptionPlanList({});
      console.log("response", response);

      setPlanListData(response);
      dispatch(setLoadingFalse());
    } catch (error) {
      dispatch(setLoadingFalse());
      console.error("Error fetching referral list:", error);
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  useEffect(() => {
    fetchPlanList();
  }, []);

  const onClickToggleStatusChange = async (data) => {
    dispatch(setLoadingTrue());
    const param = {
      planId: data._id,
      isActive: !data.isActive,
      sub_id: data.sub_id,
    };
    try {
      await apiCallSubscriptionUpdatePlanStatus(param);
      fetchPlanList();
      dispatch(setLoadingFalse());
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };

  const handleDeletePlan = async () => {
    if (!selectedDeletePlan) return;

    dispatch(setLoadingTrue());
    try {
      await apiCallSubscriptionUpdatePlanStatus({
        planId: selectedDeletePlan._id,
        isDeleted: !selectedDeletePlan.isDeleted,
        sub_id: selectedDeletePlan.sub_id,
      });
      setDeleteConfirmation(false);
      setSelectedDeletePlan(null);
      fetchPlanList();
    } catch (error) {
      dispatch(setLoadingFalse());
      console.error(error);
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  return (
    <div>
      <div className="astrologers-list-parent padding-top-bottom ">
        <div className="frame-parent2">
          <div className="custom-box-user">
            <div className="category_button">
              <button onClick={() => setOpenModal(true)}>Create Plan</button>
            </div>
          </div>
        </div>
      </div>
      <div className="Event-custom-style">
        <div className="lastWeekEndDiv Event-AlignSelf-stretch">
          <div className="user_title event-flex-container">
            Subscription Plan lists
          </div>
          <div className="transparentWhite">
            <nav className="grid-cols grid_7 fontSize16WithoutFlex transparentWhite-padding">
              <div style={{ width: "22%" }} className="user_name">
                Plan
              </div>
              <div style={{ width: "28%" }} className="user_name">
                Description
              </div>

              <div style={{ width: "8%" }} className="user_name">
                Order
              </div>
              <div style={{ width: "10%" }} className="user_name">
                Status
              </div>
              <div style={{ width: "7%" }} className="user_name">
                Action
              </div>
            </nav>

            <PlanList
              currentUsers={planListData?.data}
              onToggleStatus={onClickToggleStatusChange}
              onDelete={(item) => {
                setSelectedDeletePlan(item);
                setDeleteConfirmation(true);
              }}
              onEdit={(item) => {
                setSelectedPlan(item);
                setOpenModal(true);
              }}
            />
          </div>
        </div>
      </div>

      {openModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <CreatePlanModal
              onClose={() => {
                setOpenModal(false);
                setSelectedPlan(null);
              }}
              openModal={openModal}
              editData={selectedPlan}
              onSuccess={() => {
                setOpenModal(false);
                setSelectedPlan(null);
                fetchPlanList();
              }}
            />
          </div>
        </div>
      )}
      {planListData?.data?.length == 0 && !isLoading && (
        <div className="empty-centered">
          <EmptyData />
        </div>
      )}

      {deleteConfirmation && (
        <div
          className="modal-category"
          style={{
            zIndex: 999999,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "rgba(6, 101, 228, 1)",
              borderRadius: "8px",
              padding: "20px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              width: "auto",
              maxWidth: "800px",
              textAlign: "center",
              color: "#fff",
            }}
          >
            <p>Are you sure you want to delete this plan?</p>
            <br />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              <button
                onClick={() => handleDeletePlan()}
                style={{
                  width: "100px",
                  padding: "10px",
                  backgroundColor: "#d9534f",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  transition: "background-color 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#c9302c")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#d9534f")
                }
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setDeleteConfirmation(false);
                  setSelectedDeletePlan(null);
                }}
                style={{
                  backgroundColor: "#f0ad4e",
                  width: "100px",
                  padding: "10px",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  transition: "background-color 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#ec971f")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#f0ad4e")
                }
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubsriptionList;
